<template>

  <Header />

  <router-view />

  <Footer />
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header, Footer
  },
  mounted(){
    // const now = new Date();

    // // Obtener la hora local en GMT-5 (ajustando manualmente)
    // const utcHour = now.getUTCHours();
    // const gmtMinus5Hour = (utcHour - 5 + 24) % 24;

    // if (gmtMinus5Hour < 6 || gmtMinus5Hour >= 22) {
    //   window.location.href = "/landing";
    // }
  }
}
</script>